import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Unit } from '../../helpers/unit';
import { SummaryRow, SummaryItem, SummaryBox } from './utils';
import { dateToUTC, toDisplayTimeString } from '../../helpers/moment-ex';
import { isElasticLoad } from '../../helpers/common';
import { fetchSensorData } from '../../actions/analyze';

const SummaryTwo = props => {
    const unit = Unit.getInstance();
    const settings = props.settings;
    const analyze = useSelector(state => state.analyze.analyzeParams);
    const search = useSelector(state => state.analyze.searchParams);
    const isRequestingTravelKpi = useSelector(state => state.analyze.travelKpi.isRequesting);
    const travelKpi = useSelector(state => state.analyze.travelKpi.data);
    const range = search.range;

    const startDate = dateToUTC(search.custom.from, search.timezone).format();
    const endDate = dateToUTC(search.custom.to, search.timezone).format();

    const dispatch = useDispatch();

    useEffect(() => {
        let reqParams;
        if (range === "planned" || range === "todate") {
            reqParams = {
                farm_uuid: analyze.farmId,
                equipment_group_uuid: analyze.egId,
                sensor: "cgps0",
                range_type: range
            }
        }
        else {
            reqParams = {
                farm_uuid: analyze.farmId,
                equipment_group_uuid: analyze.egId,
                sensor: "cgps0",
                range_type: range,
                from_date: startDate,
                to_date: endDate
            }
        }
        dispatch(fetchSensorData(reqParams));
    }, [search]);

    const { workedKPI, load, speed, params } = props;
    const isManualLoad = !isElasticLoad();
    const isRequestingLoad = isManualLoad ? load.isRequesting : workedKPI.isRequesting;
    const isRequestingSpeed = speed.isRequesting;
    const distanceTravelled = travelKpi && travelKpi[analyze.egId] ? unit.toRoundOfDistance(travelKpi[analyze.egId]) : 0;

    return <>
        <h5 className="card-subtitle-1">{params.showTareLoad ? 'Tare Load' : 'Load'}</h5>
        <SummaryBox>
            <SummaryRow>
                <SummaryItem
                    title="Crew Avg Loads"
                    value={load.crew.avg_loads}
                    isLoading={isRequestingLoad}
                />
                {isManualLoad && <SummaryItem
                    title="Crew Avg Load Time"
                    value={toDisplayTimeString(load.crew.avg_load_time)}
                    isLoading={isRequestingLoad}
                />}
                <SummaryItem
                    title={params.showTareLoad ? "Total Tare Loads" : "Total Loads"}
                    value={load.vehicle.loads}
                    isLoading={isRequestingLoad}
                />
                <SummaryItem
                    title={params.showTareLoad ? "Total Tare Weight" : 'Total Load Weight'}
                    value={unit.toRoundOfWeight(load.vehicle.total_load_capacity, false)}
                    isLoading={isRequestingLoad}
                />

                <SummaryItem
                    title={params.showTareLoad ? "Avg Tare Roundtrip Load Time" : "Avg Roundtrip Load Time"}
                    value={toDisplayTimeString(load.vehicle.avg_round_trip_load_time)}
                    isLoading={isRequestingLoad}
                />

            </SummaryRow>
            <SummaryRow>
                {speed.payload.is_speed && <SummaryItem
                    title={`Avg Speed (${settings.speedShortName})`}
                    value={unit.toRoundOfSpeed(speed.payload.avg_speed)}
                    isLoading={isRequestingSpeed}
                />}
                {speed.payload.is_speed && <SummaryItem
                    title={`Max Speed (${settings.speedShortName})`}
                    value={unit.toRoundOfSpeed(speed.payload.max_speed)}
                    isLoading={isRequestingSpeed}
                />}
                {speed.payload.is_speed && <SummaryItem
                    title={`Travelled Distance (${settings.speedShortName === "mph" ? "miles" : "km"})`}
                    value={distanceTravelled}
                    isLoading={isRequestingTravelKpi} />}
            </SummaryRow>
            {/* {speed.payload.is_speed && <SummaryRow>
                <SummaryItem
                    title={`Travelled Distance(${settings.speedShortName === "mph" ? "miles" : "km"})`}
                    value={distanceTravelled}
                    isLoading={isRequestingTravelKpi}
                />
            </SummaryRow>} */}
        </SummaryBox>
    </>;
};

export default SummaryTwo;